import { create } from 'zustand';

export interface Notification {
  id: string;
  message: string;
  severity: 'error' | 'warning' | 'info' | 'success';
  /** Auto-hide delay in ms. Default 5000. Set to 0 for persistent. */
  autoHide?: number;
}

interface NotificationState {
  notifications: Notification[];
  push: (n: Omit<Notification, 'id'>) => void;
  dismiss: (id: string) => void;
  clear: () => void;
}

let counter = 0;

export const useNotificationStore = create<NotificationState>((set) => ({
  notifications: [],

  push: (n) => {
    const id = `notif-${++counter}-${Date.now()}`;
    set((s) => ({
      notifications: [...s.notifications, { ...n, id }],
    }));
  },

  dismiss: (id) =>
    set((s) => ({
      notifications: s.notifications.filter((n) => n.id !== id),
    })),

  clear: () => set({ notifications: [] }),
}));

/** Convenience helpers — importable anywhere without hooks */
export const pushNotification = (n: Omit<Notification, 'id'>) =>
  useNotificationStore.getState().push(n);

export const pushError = (message: string) =>
  pushNotification({ message, severity: 'error' });

export const pushSuccess = (message: string) =>
  pushNotification({ message, severity: 'success', autoHide: 3000 });

export const pushWarning = (message: string) =>
  pushNotification({ message, severity: 'warning' });
